import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import {UserRoleEnum} from '@/enums/userRolesEnum'
import StateControl from '@/componentsReusable/StateControl.vue'
import MaskedInput from 'vue-text-mask'
import emailMask from 'text-mask-addons/dist/emailMask'
import providerEventHub from '@/components/provider/ProviderEventHub';
import {convertDateStringToUTCDate} from "@/utils/dateUtil";
import InputAndError from "@/componentsReusable/InputAndError.vue";
import {InputType} from "@/componentsReusable/InputType";

export default Vue.component('general-information-card', {
  name: 'GeneralInformationCard',
  props: {
    'new-provider': { type: Boolean, default: false}
  },
  data () {
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewProvider: false,
      providers: [{}],
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      pendingDeleteProvider: null,
      oldAddress1: "",
      oldCity: "",
      oldStateId: 0,
      oldZip: 0,
      oldStatusId: 0,
      emailMask: emailMask,
      providerTypes: [],
      statuses: [],
      InputType: InputType,
    }
  },
  components: {
    flatPickr,
    BallPulseLoader,
    VueSimpleSpinner,
    StateControl,
    MaskedInput,
    InputAndError
  },
  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER) && !(this as any).newProvider;
    }
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  mounted: function () {
    this.expandCard();
    this.getProviderTypes();
  },
  created: function () {
    providerEventHub.$on('PROVIDER_PROFILE_CHANGE', this.providerChangeEvent)
  },
  beforeDestroy: function () {
    providerEventHub.$off('PROVIDER_PROFILE_CHANGE', this.providerChangeEvent)
  },
  filters: {
    nickname (nickName: string ) {
      if (nickName && nickName.length) {
        return '(' + nickName + ')';
      }
      return '';
    },
    title (title: string ) {
      if (title && title.length) {
        return ' | ' + title;
      }
      return '';
    },
    phoneNumber (phoneNumber: string) {
      let formattedPhoneNumber = phoneNumber;
      if (phoneNumber && phoneNumber.length) {
        let phoneNumberArray = phoneNumber.match(/(\d)?(\d\d\d)?(\d\d\d)(\d\d\d\d)$/);
        if (!phoneNumberArray) { return formattedPhoneNumber; }
        formattedPhoneNumber = phoneNumberArray.length ? '' : formattedPhoneNumber;
        for (let i = 1; i < phoneNumberArray.length; i++) {
          if (phoneNumberArray[i]) {
            formattedPhoneNumber += phoneNumberArray[i] + '.';
          }
        }
        formattedPhoneNumber = formattedPhoneNumber.slice(0,formattedPhoneNumber.length - 1);
      } else {
        formattedPhoneNumber = 'NA';
      }
      return formattedPhoneNumber;
    },
    state (state: string) {
      if (state && state.length) {
        return ', ' + state;
      }
      return '';
    },
    address2 (address2: string) {
      if (address2 && address2.length) {
        return ', ' + address2;
      }
      return '';
    }
  },
  methods: {
    providerChangeEvent () {
      setTimeout( () => {
        this.getProviderInformation()
      },0);
    },
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getProviderInformation()
      }
    },
    getProviderTypes () {
      if (this.isProviderUser) {
        return;
      }
      let self = this
      HTTP.get('/api/provider-types/')
      .then(function (response) {
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Provider types.");
        }
        self.providerTypes = response.data.data;
      })
      .catch(function (err) {
        console.log(err);
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Provider types.'
        });
      })
    },
    getProviderInformation () {
      if ((this as any).newProvider) {
        this.providers = [{
          providerId: 0,
          firstName: "",
          middleName: "",
          lastName: "",
          nickname: "",
          titleId: 0,
          title: "",
          statusId: 1,
          status: "PENDING",
          phoneHome: "",
          phoneCell: "",
          email: "",
          address1: "",
          address2: "",
          city: "",
          stateId: null,
          state: null,
          zip: "",
          mailingAddress1: "",
          mailingAddress2: "",
          mailingCity: "",
          mailingStateId: null,
          mailingState: null,
          mailingZip: "",
          isBoardCertified: false,
          isEmployed: false,
          isNew: true,
          active: false,
          isEditing: true,
          updatingData: false,
          socialSecurityNumber: "",
          dateOfBirth: "",
          cityOfBirth: "",
          nationalProviderIdentifierNumber: "",
          medicareProviderNumber: "",
          maidenName: "",
          gender: "",
          driversLicenseNumber: "",
          driversLicenseExpiration: "",
          driversLicenseStateId: "",
          driversLicenseState: "",
          socialSecurityNumberErrorMessage: '',
          dateOfBirthErrorMessage: '',
          cityOfBirthErrorMessage: '',
          nationalProviderIdentifierNumberErrorMessage: '',
          medicareProviderNumberErrorMessage: '',
          maidenNameErrorMessage: '',
          genderErrorMessage: '',
          driversLicenseNumberErrorMessage: '',
          driversLicenseExpirationErrorMessage: '',
          driversLicenseStateIdErrorMessage: '',
          driversLicenseStateErrorMessage: '',
          isVeteran: false
        }];

        return;
      }

      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/providers/' + this.$route.params.providerId + '/general-information')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Provider information.");
        }
        let providerInformation = response.data.data;
        providerInformation.isEditing = false;
        providerInformation.isNew = false;
        providerInformation.updatingData = false;
        providerInformation.middleNameErrorMessage = '';
        providerInformation.socialSecurityNumberErrorMessage = '';
        providerInformation.dateOfBirthErrorMessage = '';
        providerInformation.cityOfBirthErrorMessage = '';
        providerInformation.nationalProviderIdentifierNumberErrorMessage = '';
        providerInformation.medicareProviderNumberErrorMessage = '';
        providerInformation.maidenNameErrorMessage = '';
        providerInformation.genderErrorMessage = '';
        providerInformation.driversLicenseNumberErrorMessage = '';
        providerInformation.driversLicenseExpirationErrorMessage = '';
        providerInformation.driversLicenseStateIdErrorMessage = '';
        providerInformation.driversLicenseStateErrorMessage = '';
        providerInformation.isVeteran = (providerInformation.veteran ? true : false);
        if (providerInformation.driversLicenseExpiration != null) {
          providerInformation.driversLicenseExpiration = convertDateStringToUTCDate(providerInformation.driversLicenseExpiration);
        }

        self.oldAddress1 = providerInformation.address1;
        self.oldCity = providerInformation.city;
        self.oldStateId = providerInformation.stateId;
        self.oldZip = providerInformation.zip;
        self.oldStatusId = providerInformation.statusId;
        self.providers = [providerInformation];
        self.$emit('provider-loaded', providerInformation);
      })
      .catch(function () {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Provider information.'
        });
      })
    },
    titleChange (provider: any) {
      this.providerTypes.forEach(function (type: any) {
        if (provider.titleId === type.id) {
          provider.title = type.name;
        }
      });
    },
    stateSelected (state: any, provider: any) {
      provider.stateId = state.stateId;
      provider.state = state.stateAbbrev;
    },
    mailingStateSelected (state: any, provider: any) {
      provider.mailingStateId = state.stateId;
      provider.mailingState = state.stateAbbrev;
    },
    driversLicenseStateSelected (state: any, provider: any) {
      provider.driversLicenseStateId = state.stateId;
      provider.driversLicenseState = state.stateAbbrev;
    },
    saveProvider (newProvider: any) {
      let self = this
      self.savingNewProvider = true;
      HTTP.post('/api/providers/', newProvider)
      .then(async (response) => {
        self.savingNewProvider = false;
        newProvider.isEditing = false;
        if (!response.data || !response.data.data || !response.data.data.providerId) {
          throw new Error("Error saving Provider information.");
        }
        newProvider.isNew = false;
        // This will put the "getProviderInformation()" execution on the next js cycle,
        // after the page has been re-directed
        //
        // If New Provider starts out as Active, set distances to all Active Facilities
        if (newProvider.statusId === 2) {
          await self.updateDistances(newProvider);
        }
        setTimeout(function () {
          self.getProviderInformation();
        },0);
        self.$router.replace({ name: 'Provider', params: { providerId: response.data.data.providerId }});
      })
      .catch(function (error) {
        self.savingNewProvider = false;

        newProvider.firstNameErrorMessage = getRestParamErrorMessage(error, 'firstName');
        newProvider.middleNameErrorMessage = getRestParamErrorMessage(error, 'middleName');
        newProvider.lastNameErrorMessage = getRestParamErrorMessage(error, 'lastName');
        newProvider.nicknameErrorMessage = getRestParamErrorMessage(error, 'nickname');
        newProvider.titleIdErrorMessage = getRestParamErrorMessage(error, 'titleId');
        newProvider.phoneHomeErrorMessage = getRestParamErrorMessage(error, 'phoneHome');
        newProvider.phoneCellErrorMessage = getRestParamErrorMessage(error, 'phoneCell');
        newProvider.emailErrorMessage = getRestParamErrorMessage(error, 'email');
        newProvider.isBoardCertifiedErrorMessage = getRestParamErrorMessage(error, 'isBoardCertified');
        newProvider.isEmployedErrorMessage = getRestParamErrorMessage(error, 'isEmployed');
        // newProvider.statusIdErrorMessage = getRestParamErrorMessage(error, 'statusId');
        newProvider.address1ErrorMessage = getRestParamErrorMessage(error, 'address1');
        newProvider.address2ErrorMessage = getRestParamErrorMessage(error, 'address2');
        newProvider.cityErrorMessage = getRestParamErrorMessage(error, 'city');
        newProvider.stateErrorMessage = getRestParamErrorMessage(error, 'state');
        newProvider.zipErrorMessage = getRestParamErrorMessage(error, 'zip');
        newProvider.mailingAddress1ErrorMessage = getRestParamErrorMessage(error, 'mailingAddress1');
        newProvider.mailingAddress2ErrorMessage = getRestParamErrorMessage(error, 'mailingAddress2');
        newProvider.mailingCityErrorMessage = getRestParamErrorMessage(error, 'mailingCity');
        newProvider.mailingStateErrorMessage = getRestParamErrorMessage(error, 'mailingState');
        newProvider.mailingZipErrorMessage = getRestParamErrorMessage(error, 'mailingZip');
        newProvider.socialSecurityNumberErrorMessage = getRestParamErrorMessage(error, 'socialSecurityNumber');
        newProvider.dateOfBirthErrorMessage = getRestParamErrorMessage(error, 'dateOfBirth');
        newProvider.cityOfBirthErrorMessage = getRestParamErrorMessage(error, 'cityOfBirth');
        newProvider.nationalProviderIdentifierNumberErrorMessage = getRestParamErrorMessage(error, 'nationalProviderIdentifierNumber');
        newProvider.medicareProviderNumberErrorMessage = getRestParamErrorMessage(error, 'medicareProviderNumber');
        newProvider.maidenNameErrorMessage = getRestParamErrorMessage(error, 'maidenName');
        newProvider.genderErrorMessage = getRestParamErrorMessage(error, 'gender');
        newProvider.driversLicenseNumberErrorMessage = getRestParamErrorMessage(error, 'driversLicenseNumber');
        newProvider.driversLicenseExpirationErrorMessage = getRestParamErrorMessage(error, 'driversLicenseExpiration');
        newProvider.driversLicenseStateIdErrorMessage = getRestParamErrorMessage(error, 'driversLicenseStateId');
        newProvider.driversLicenseStateErrorMessage = getRestParamErrorMessage(error, 'driversLicenseState');

        if (
          !newProvider.firstNameErrorMessage.length &&
          !newProvider.middleNameErrorMessage.length &&
          !newProvider.lastNameErrorMessage.length &&
          !newProvider.nicknameErrorMessage.length &&
          !newProvider.titleIdErrorMessage.length &&
          !newProvider.phoneHomeErrorMessage.length &&
          !newProvider.phoneCellErrorMessage.length &&
          !newProvider.emailErrorMessage.length &&
          !newProvider.isBoardCertifiedErrorMessage.length &&
          !newProvider.isEmployedErrorMessage.length &&
          // !newProvider.statusIdErrorMessage.length &&
          !newProvider.address1ErrorMessage.length &&
          !newProvider.address2ErrorMessage.length &&
          !newProvider.cityErrorMessage.length &&
          !newProvider.stateErrorMessage.length &&
          !newProvider.zipErrorMessage.length &&
          !newProvider.mailingAddress1ErrorMessage.length &&
          !newProvider.mailingAddress2ErrorMessage.length &&
          !newProvider.mailingCityErrorMessage.length &&
          !newProvider.mailingStateErrorMessage.length &&
          !newProvider.mailingZipErrorMessage.length &&
          !newProvider.socialSecurityNumberErrorMessage &&
          !newProvider.dateOfBirthErrorMessage &&
          !newProvider.cityOfBirthErrorMessage &&
          !newProvider.nationalProviderIdentifierNumberErrorMessage &&
          !newProvider.medicareProviderNumberErrorMessage &&
          !newProvider.maidenNameErrorMessage &&
          !newProvider.genderErrorMessage &&
          !newProvider.driversLicenseNumberErrorMessage &&
          !newProvider.driversLicenseExpirationErrorMessage &&
          !newProvider.driversLicenseStateIdErrorMessage &&
          !newProvider.driversLicenseStateErrorMessage
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Saving',
            text: generalError ? generalError : 'An error occurred saving provider.',
            // duration: 5000
          });
        }

      })
    },
    updateProvider (updatedProvider: any) {
      let self = this
      updatedProvider.updatingData = true;
      if (updatedProvider.active !== true) {
        updatedProvider.active = false;
      }
      HTTP.put('/api/providers/', updatedProvider)
      .then(async (response) => {
        updatedProvider.updatingData = false;
        updatedProvider.isEditing = false;
        self.getProviderInformation();
        if (updatedProvider.address1 !== self.oldAddress1 || updatedProvider.city !== self.oldCity || updatedProvider.stateId !== self.oldStateId || updatedProvider.zip !== self.oldZip || (self.oldStatusId !== 2 && updatedProvider.statusId === 2) ) {
          if (updatedProvider.statusId === 2) {
            await self.updateDistances(updatedProvider);
          }
        }
      })
      .catch(function (error) {
        updatedProvider.updatingData = false;

        updatedProvider.firstNameErrorMessage = getRestParamErrorMessage(error, 'firstName');
        updatedProvider.middleNameErrorMessage = getRestParamErrorMessage(error, 'middleName');
        updatedProvider.lastNameErrorMessage = getRestParamErrorMessage(error, 'lastName');
        updatedProvider.nicknameErrorMessage = getRestParamErrorMessage(error, 'nickname');
        updatedProvider.titleIdErrorMessage = getRestParamErrorMessage(error, 'titleId');
        updatedProvider.phoneHomeErrorMessage = getRestParamErrorMessage(error, 'phoneHome');
        updatedProvider.phoneCellErrorMessage = getRestParamErrorMessage(error, 'phoneCell');
        updatedProvider.emailErrorMessage = getRestParamErrorMessage(error, 'email');
        updatedProvider.isBoardCertifiedErrorMessage = getRestParamErrorMessage(error, 'isBoardCertified');
        updatedProvider.isEmployedErrorMessage = getRestParamErrorMessage(error, 'isEmployed');
        updatedProvider.active = getRestParamErrorMessage(error, "active");
        updatedProvider.address1ErrorMessage = getRestParamErrorMessage(error, 'address1');
        updatedProvider.address2ErrorMessage = getRestParamErrorMessage(error, 'address2');
        updatedProvider.cityErrorMessage = getRestParamErrorMessage(error, 'city');
        updatedProvider.stateErrorMessage = getRestParamErrorMessage(error, 'state');
        updatedProvider.zipErrorMessage = getRestParamErrorMessage(error, 'zip');
        updatedProvider.mailingAddress1ErrorMessage = getRestParamErrorMessage(error, 'mailingAddress1');
        updatedProvider.mailingAddress2ErrorMessage = getRestParamErrorMessage(error, 'mailingAddress2');
        updatedProvider.mailingCityErrorMessage = getRestParamErrorMessage(error, 'mailingCity');
        updatedProvider.mailingStateErrorMessage = getRestParamErrorMessage(error, 'mailingState');
        updatedProvider.mailingZipErrorMessage = getRestParamErrorMessage(error, 'mailingZip');
        updatedProvider.socialSecurityNumberErrorMessage = getRestParamErrorMessage(error, 'socialSecurityNumber');
        updatedProvider.dateOfBirthErrorMessage = getRestParamErrorMessage(error, 'dateOfBirth');
        updatedProvider.cityOfBirthErrorMessage = getRestParamErrorMessage(error, 'cityOfBirth');
        updatedProvider.nationalProviderIdentifierNumberErrorMessage = getRestParamErrorMessage(error, 'nationalProviderIdentifierNumber');
        updatedProvider.medicareProviderNumberErrorMessage = getRestParamErrorMessage(error, 'medicareProviderNumber');
        updatedProvider.maidenNameErrorMessage = getRestParamErrorMessage(error, 'maidenName');
        updatedProvider.genderErrorMessage = getRestParamErrorMessage(error, 'gender');
        updatedProvider.driversLicenseNumberErrorMessage = getRestParamErrorMessage(error, 'driversLicenseNumber');
        updatedProvider.driversLicenseExpirationErrorMessage = getRestParamErrorMessage(error, 'driversLicenseExpiration');
        updatedProvider.driversLicenseStateIdErrorMessage = getRestParamErrorMessage(error, 'driversLicenseStateId');
        updatedProvider.driversLicenseStateErrorMessage = getRestParamErrorMessage(error, 'driversLicenseState');

        if (
          !updatedProvider.firstNameErrorMessage.length &&
          !updatedProvider.middleNameErrorMessage.length &&
          !updatedProvider.lastNameErrorMessage.length &&
          !updatedProvider.nicknameErrorMessage.length &&
          !updatedProvider.titleIdErrorMessage.length &&
          !updatedProvider.phoneHomeErrorMessage.length &&
          !updatedProvider.phoneCellErrorMessage.length &&
          !updatedProvider.emailErrorMessage.length &&
          !updatedProvider.isBoardCertifiedErrorMessage.length &&
          !updatedProvider.isEmployedErrorMessage.length &&
          // !updatedProvider.statusIdErrorMessage.length &&
          !updatedProvider.address1ErrorMessage.length &&
          !updatedProvider.address2ErrorMessage.length &&
          !updatedProvider.cityErrorMessage.length &&
          !updatedProvider.stateErrorMessage.length &&
          !updatedProvider.zipErrorMessage.length &&
          !updatedProvider.mailingAddress1ErrorMessage.length &&
          !updatedProvider.mailingAddress2ErrorMessage.length &&
          !updatedProvider.mailingCityErrorMessage.length &&
          !updatedProvider.mailingStateErrorMessage.length &&
          !updatedProvider.mailingZipErrorMessage.length &&
          !updatedProvider.socialSecurityNumberErrorMessage.length &&
          !updatedProvider.dateOfBirthErrorMessage.length &&
          !updatedProvider.cityOfBirthErrorMessage.length &&
          !updatedProvider.nationalProviderIdentifierNumberErrorMessage.length &&
          !updatedProvider.medicareProviderNumberErrorMessage.length &&
          !updatedProvider.maidenNameErrorMessage.length &&
          !updatedProvider.genderErrorMessage.length &&
          !updatedProvider.driversLicenseNumberErrorMessage.length &&
          !updatedProvider.driversLicenseExpirationErrorMessage.length &&
          !updatedProvider.driversLicenseStateIdErrorMessage.length &&
          !updatedProvider.driversLicenseStateErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating provider.',
            // duration: 5000
          });
        }

      })
    },
    toggleEditProvider (provider: any) {
      if (this.isProviderUser) {
        return;
      }
      let selectedCredId = provider.providerId;
      // Collapse any editing providers
      // Delete any existing "new" providers
      let indexesToDelete: any = [];
      this.providers.forEach(function (cred: any, index) {
        if (cred.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedCredId !== cred.providerId) {
          cred.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.providers.splice(indx,1);
      })
      provider.isEditing = !provider.isEditing;
    },
    addProvider () {
      // Collapse any editing providers
      // Delete any existing "new" providers
      let indexesToDelete: any = [];
      this.providers.forEach(function (cred: any, index) {
        if (cred.isNew) {
          indexesToDelete.push(index);
        }
        cred.isEditing = false;
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.providers.splice(indx,1);
      })

      let expirationDate = new Date();
      expirationDate.setFullYear(expirationDate.getFullYear() + 1);
      this.providers.unshift(
        {
          "providerId": this.$route.params.providerId,
          "facilityId": null,
          "facilityName": "",
          "facilityNickName": "",
          "issuedDate": new Date(),
          "expirationDate": expirationDate,
          "expirationNoticeDate": null,
          "isWelcomed": true,
          "note": "",
          "isNew": true,
          "isEditing": true
        }
      );
    },
    async updateDistances (provider: any): Promise<void> {
      try {
        await HTTP.put('/api/providers/update-distances/', provider);
      } catch (err) {
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Updating Distances.',
          text: 'Save successful but an unknown error occurred while updating Distances.',
        });
      }
    },
    cancel (provider: any) {
      provider.isEditing = false;
      if (provider.isNew) {
        this.$router.push({name: 'Providers'});
      } else {
        this.getProviderInformation();
      }
    },
    onCopy (param: any) {
      this.$notify({
        group: 'main',
        type: 'success',
        title: 'Successfully Copied',
        text: 'Text ' + param.text + ' has been copied.',
      });
    },
    onError (param: any) {
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error Copying',
        text: 'Something went wrong copying to your clipboard.',
      });
    },
  }
})



// WEBPACK FOOTER //
// ./src/components/provider/cards/generalInformation/GeneralInformationCard.ts